import React from "react";
import { useState, useEffect } from "react";
import "./Pavalsoft_Lp.css";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import CONFIG from "../src/config";
import AnimatedSlider from "./PavalMainSlider";
import PavalTestimonial from "./PavalTestimonial";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";

const Pavalsoft_lp = () => {
  const meta = metaConfig.pavalsoft;

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [closing, setClosing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    businessName: "",
    email: "",
    phone: "",
    countryCode: "+91",
    businessType: "",
    enquiry: "",
  });

  const countryCodes = [
    { code: "+91", name: "India", flag: "IN" },
    { code: "+44", name: "UK", flag: "UK" },
    { code: "+61", name: "AU", flag: "AU" },
  ];
  const [errors, setErrors] = useState({});

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setShowModal(false);
      setClosing(false);
      setFormData({
        firstName: "",
        businessName: "",
        email: "",
        phone: "",
        countryCode: "+91",
        businessType: "",
        enquiry: "",
      });
      setErrors({});
    }, 3000);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "firstName") {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(value)) return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.firstName.trim()) {
      newErrors.firstName = "Full name is required";
    }
    if (!formData.businessName.trim()) {
      newErrors.businessName = "Business name is required";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    const fullPhoneNumber = `${formData.countryCode}${formData.phone}`.replace(
      /\s+/g,
      ""
    );
    const indianPhonePattern = /^\+91[6789]\d{9}$/;
    const ukPhonePattern = /^\+447\d{9}$/;
    const australiaPhonePattern = /^\+614\d{8}$/;

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (
      formData.countryCode === "+91" &&
      !indianPhonePattern.test(fullPhoneNumber)
    ) {
      newErrors.phone =
        "Indian mobile numbers must start with 6,7,8, or 9 and be 10 digits long.";
    } else if (
      formData.countryCode === "+44" &&
      !ukPhonePattern.test(fullPhoneNumber)
    ) {
      newErrors.phone =
        "UK mobile numbers must start with 7 after +44 and be 10 digits long.";
    } else if (
      formData.countryCode === "+61" &&
      !australiaPhonePattern.test(fullPhoneNumber)
    ) {
      newErrors.phone =
        "Australian mobile numbers must start with 4 after +61 and be 9 digits long.";
    } else if (
      formData.countryCode !== "+91" &&
      formData.countryCode !== "+44" &&
      formData.countryCode !== "+61"
    ) {
      newErrors.phone = "Unsupported country code.";
    }

    if (!formData.businessType) {
      newErrors.businessType = "Please select a business type";
    }
    if (!formData.enquiry) {
      newErrors.enquiry = "Message is required";
    }

    // If there are any errors, update the error state and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // Don't proceed with form submission
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${CONFIG.BASE_URL}/career/apply/paval-business-enquiry`,
        {
          firstName: `${formData.firstName}`,
          businessName: `${formData.businessName}`,
          email: `${formData.email}`,
          phone: `${formData.countryCode} ${formData.phone}`,
          businessType: `${formData.businessType}`,
          enquiry: `${formData.enquiry}`,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 201 || response.status === 200) {
        toast.success("Business Enquiry submitted!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setFormData({
          firstName: "",
          businessName: "",
          email: "",
          phone: "",
          businessType: "",
          enquiry: "",
        });

        setErrors({});
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }

    if (Object.keys(newErrors).length === 0) {
      closeModal();
    }
  };

  return (
    <div>
      <SEO {...meta} />
      <div className="paval_mainwrap">
        <ToastContainer />

        <div className="container-fluid  position-relative p-0">
          <div className="mt-0 paval-mainheader">
            <div className="col-12 top_menuitem mx-auto item-align-end">
              <nav className="navbar  container mx-auto py-1">
                <div className="topemailwrap">
                  <a href="mailto:info@pavalsoftware.com" className="p-0">
                    <div className="contacticon">
                      <img
                        src="assets/img/pavalsoft/email_icon.png"
                        alt="Pavalsoft"
                      />
                    </div>
                    <span>info@pavalsoftware.com </span>
                  </a>
                </div>

                <div className="d-flex topright_head">
                  <div className="topcontactwrap ind-ph">
                    <a href="tel:+91 6380 750 902" className="">
                      <div className="contacticon">
                        {" "}
                        <img
                          src="assets/img/pavalsoft/indflag.png"
                          alt="Pavalsoft"
                        />
                      </div>{" "}
                      <span>+91 6380 750 902 </span>
                    </a>
                  </div>
                  <div className="topcontactwrap uk-ph">
                    <a href="tel:+44 740 270 2107" className="">
                      <div className="contacticon">
                        <img
                          src="assets/img/pavalsoft/ukflag.png"
                          alt="Pavalsoft"
                        />
                      </div>{" "}
                      <span>+44 740 270 2107 </span>
                    </a>
                  </div>
                  <div className="topcontactwrap aus-ph">
                    <a href="tel:+61 449 840 901" className="">
                      <div className="contacticon">
                        <img
                          src="assets/img/pavalsoft/ausflag.png"
                          alt="Pavalsoft"
                        />
                      </div>{" "}
                      <span>+61 449 840 901 </span>
                    </a>
                  </div>
                </div>
              </nav>
            </div>

            <div className="col-12 bannerheader mx-auto item-align-end">
              <div className="bannerheader_pattern">
                <nav className="navbar container mx-auto py-3">
                  <div className="logo">
                    <a href="https://www.pavalsoftware.com/" className="p-0">
                      <img
                        src="assets/img/pavalsoft/ps_logo.png"
                        alt="Pavalsoft"
                      />
                    </a>
                  </div>

                  <div className="d-flex topright_head">
                    <div className="logincta d-inline-flex">
                      <a onClick={openModal} className="open-button">
                        Join with Us
                      </a>
                    </div>
                    <span className="breakline"></span>
                    <div className="business_quote">
                      <p className="m-0">
                        Meet{" "}
                        <span className="text-white">Next Level Business</span>{" "}
                      </p>
                    </div>
                  </div>
                </nav>
              </div>
            </div>

            <div className="container-fluid p-0 overflow-hide mt-0">
              <div
                className="text-center mt-0 mx-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="bannerstage">
                  <>
                    <AnimatedSlider />
                  </>
                  <div className="bannerstage_bottom"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid paval_bg_white overflow-hide justify-contnet-center mt-0">
          <div className="container m-auto">
            <div className="col-md-12 paval_feature py-5 d-inline-block m-auto">
              <div className="reverse_table col-xl-8 d-inline-block">
                <div className="d-inline-block split_table1 col-xl-6  ">
                  <div class=" col-md-12  ">
                    <div class="p-4">
                      <div class="d-flex">
                        <div class="pe-3">
                          <div class="service-btn">
                            <img
                              class="w-100 d-flex mx-auto"
                              src="assets/img/pavalsoft/feature1.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div>
                          <h5 class="h5 d-inline-block mb-2">
                            Requirement Gathering
                          </h5>
                          <p class="mb-0 ">
                            The company uses detailed stakeholder assessments to
                            transform your business requirements into direct
                            project specifications.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" col-md-12 ">
                    <div class="p-4">
                      <div class="d-flex">
                        <div class="pe-3">
                          <div class="service-btn">
                            <img
                              class="w-100 d-flex mx-auto"
                              src="assets/img/pavalsoft/feature2.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div>
                          <h5 class="h5 d-inline-block mb-2">
                            Design and Prototyping
                          </h5>
                          <p class="mb-0 ">
                            User experience excellence from initial ideas
                            emerges through the design team's creation of both
                            interactive prototypes and intuitive wireframes.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-inline-block col-xl-6  ">
                  <div class=" col-md-12">
                    <div className="col-md-12 feature_title">
                      <h3 class=" d-inline-block mb-2">
                        Web Development Workflow
                      </h3>
                    </div>
                    <div class="emptycard col-md-12 md-none ">
                      <div class="p-4">
                        <div class="d-flex">
                          <div class="pe-3">
                            <div class="p-1"></div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-inline-block split_table2 col-xl-4  ">
                <div class="col-md-12  ">
                  <div class="p-4">
                    <div class="d-flex">
                      <div class="pe-3">
                        <div class="service-btn">
                          <img
                            class="w-100 d-flex mx-auto"
                            src="assets/img/pavalsoft/feature3.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="h5 d-inline-block mb-2">
                          Testing and Quality Assurance
                        </h5>
                        <p class="mb-0 ">
                          Our testing procedures focus on every website
                          component for ensuring the best possible performance
                          together with security features which function
                          seamlessly on all available browsers and devices.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" col-md-12 ">
                  <div class="p-4">
                    <div class="d-flex">
                      <div class="pe-3">
                        <div class="service-btn">
                          <img
                            class="w-100 d-flex mx-auto"
                            src="assets/img/pavalsoft/feature4.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="h5 d-inline-block mb-2">
                          Maintenance and Support
                        </h5>
                        <p class="mb-0 ">
                          Our team provides continuing support while maintaining
                          regular updates and addressing security standards to
                          keep your website safe and functional at all times.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-inline-block col-xl-4  ">
                <div class="col-md-12  ">
                  <div class="p-4">
                    <div class="d-flex">
                      <div class="pe-3">
                        <div class="service-btn">
                          <img
                            class="w-100 d-flex mx-auto"
                            src="assets/img/pavalsoft/feature5.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="h5 d-inline-block mb-2">
                          Planning and Strategy
                        </h5>
                        <p class="mb-0 ">
                          The team builds a complete project strategy that
                          delivers specific milestones with defined schedules to
                          achieve quick and effective delivery.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-inline-block col-xl-4  ">
                <div class="col-md-12  ">
                  <div class="p-4">
                    <div class="d-flex">
                      <div class="pe-3">
                        <div class="service-btn">
                          <img
                            class="w-100 d-flex mx-auto"
                            src="assets/img/pavalsoft/feature6.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="h5 d-inline-block mb-2">Development</h5>
                        <p class="mb-0 ">
                          Skilled developers within our organization create
                          strong web applications along with contemporary
                          technologies and latest coding techniques.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-inline-block col-xl-4  ">
                <div class="col-md-12  ">
                  <div class="p-4">
                    <div class="d-flex">
                      <div class="pe-3">
                        <div class="service-btn">
                          <img
                            class="w-100 d-flex mx-auto"
                            src="assets/img/pavalsoft/feature7.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="h5 d-inline-block mb-2">
                          Deployment and Launch
                        </h5>
                        <p class="mb-0 ">
                          We provide the complete deployment and launch services
                          for your website, so you achieve a seamless online
                          transition.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid  paval_bg_white justify-contnet-center ps-0 pe-0 pb-5">
          <div className=" pattertile p-0"></div>
          <div className="col-md-12 container py-5 paval_portfolwrap m-auto">
            <div className="col-md-12 text-center p-4">
              {" "}
              <h3 class=" d-inline-block mb-5">
                Paval soft <span className="title_green">Portfolio</span>
              </h3>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/ktig.png"
                  alt=""
                />
              </div>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/ktnlweb.jpg"
                  alt=""
                />
              </div>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/skillorealp1.jpg"
                  alt=""
                />
              </div>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/bracademy.jpg"
                  alt=""
                />
              </div>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/multiscale.jpg"
                  alt=""
                />
              </div>
            </div>

            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/skillorealp.jpg"
                  alt=""
                />
              </div>
            </div>
            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/bnrcogniitec.png"
                  alt=""
                />
              </div>
            </div>
            <div class=" col-md-3 d-inline-flex">
              <div class="portfolio ms-auto">
                <div className="img_overlay"></div>
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/pavalweb.jpg"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-12 text-center p-4">
              <div className="cta mt-3 d-inline-flex">
                <a href="https://www.pavalsoftware.com/about-us" className="">
                  View More
                </a>
              </div>
            </div>
          </div>
          <div className="pattertilewhite p-0"></div>
        </div>

        <div className="container-fluid overflow-hide pricinwrap justify-contnet-center pe-0">
          <div className="pattertileblack p-0"></div>
          <div className="col-md-12 py-5 d-flex paval_pricing m-auto">
            <div class=" col-md-6 d-inline-flex">
              <div class="handpic ms-auto">
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/girlwithlap.png"
                  alt=""
                />
              </div>
            </div>
            <div class=" col-md-6 d-inline-flex">
              <div class=" ml-auto">
                <div className="quickenquiry">
                  <h3 class="d-inline-block mb-0">No Limits</h3>
                  <p>
                    Envision Your Ideal Website <br />— We’ll Bring It to Life
                  </p>
                  <div className="cta_group mt-3  d-flex">
                    <div className="cta mt-3 me-3">
                      <a onClick={openModal} className="open-button">
                        Request a Consultation
                      </a>
                    </div>

                    <div className="cta mt-3">
                      <a
                        href="https://www.pavalsoftware.com/contact-us"
                        className=""
                      >
                        Connect with Our Team
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pb-5">
            <div className="col-md-12  businesstag text-center ">
              <h3 className="text-center mt-5">
                Our expert team handles everything—ensuring your website is
                thoughtfully designed, flawlessly built, and ready to perform.
              </h3>
              <h5>
                <span className="sectiontitle_line"></span>Start Building a
                Smarter Digital Future Today
                <span className="sectiontitle_line"></span>
              </h5>
            </div>
            <div className="col-md-12 py-5 d-flex paval_princingplan m-auto">
              <div class=" col-md-3 d-inline-flex">
                <a onClick={openModal} className="open-button cardwrap">
                  <div class="pricing_card ">
                    <div className="cardtitle text-center">
                      <h5>Starter</h5>
                    </div>
                    <p className="itemlist text-center">Up to 5 Pages</p>
                    <div className="cardprice_details">
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SEO-Optimized Content </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>On-Page SEO </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Google Analytics Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Free Firewall Setup </p>
                      </div>

                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SSL Certificate </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Speed Optimization</p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Priority Support </p>
                      </div>
                      <div className="cta mt-3 text-center m-auto">
                        <a onClick={openModal} className="open-button">
                          Enquire Now
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class=" col-md-3 d-inline-flex">
                <a onClick={openModal} className="open-button cardwrap">
                  <div class="pricing_card ">
                    <div className="cardtitle text-center">
                      <h5>Professional</h5>
                    </div>
                    <p className="itemlist text-center">Up to 3 Forms</p>
                    <div className="cardprice_details">
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SEO-Optimized Content </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>On-Page SEO </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Google Analytics Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Free Firewall Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SSL Certificate </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Speed Optimization </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Priority Support </p>
                      </div>

                      <div className="cta mt-3 text-center m-auto">
                        <a onClick={openModal} className="open-button">
                          Enquire Now
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class=" col-md-3 d-inline-flex">
                <a onClick={openModal} className="open-button cardwrap">
                  <div class="pricing_card ">
                    <div className="cardtitle text-center">
                      <h5>Business</h5>
                    </div>
                    <p className="itemlist text-center">Up to 18 Forms </p>
                    <div className="cardprice_details">
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SEO-Optimized Content </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>On-Page SEO </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Google Analytics Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Free Firewall Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SSL Certificate </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Speed Optimization </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Priority Support (Email & Phone) </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Custom E-Commerce Design </p>
                      </div>
                      <div className="cta mt-3 text-center m-auto">
                        <a onClick={openModal} className="open-button">
                          Enquire Now
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class=" col-md-3 d-inline-flex">
                <a onClick={openModal} className="open-button cardwrap">
                  <div class="pricing_card ">
                    <div className="cardtitle text-center">
                      <h5>E-Commerce</h5>
                    </div>
                    <p className="itemlist text-center">
                      Up to 5 Pages + 1 Store Page (10 Products)
                    </p>
                    <div className="cardprice_details">
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SEO-Optimized Content </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>On-Page SEO </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Google Analytics Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Free Firewall Setup </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>SSL Certificate </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Speed Optimization </p>
                      </div>

                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Priority Support (Email & Phone) </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Custom E-Commerce Design </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Enquiry Form, Newsletter, User Registration </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Mega Menu + Custom Product Upload </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>Payment Gateway Integration </p>
                      </div>
                      <div className="pricing_carditem d-flex">
                        <div className="p-2">
                          <i class="fas fa-check me-2"></i>
                        </div>
                        <p>API Integration </p>
                      </div>
                      <div className="cta mt-3 text-center m-auto">
                        <a onClick={openModal} className="open-button">
                          Enquire Now
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid pavaltestimonial">
          <div className="col-md-8 m-auto">
            <h3 class="d-inline-block mb-2">Testimonial</h3>
          </div>
          <div className="container">
            <PavalTestimonial />
          </div>
        </div>

        <div className="container-fluid overflow-hide overbottom grey_grady justify-contnet-center pe-0 pb-0 py-5">
          <div className="col-md-12 py-5 pb-0 d-flex paval_about m-auto">
            <div class=" col-md-6 d-inline-block ">
              <div class="paval_details">
                <div>
                  <h3 class="d-inline-block mb-2">
                    <span className="title_green">Paval Soft:</span> {""}All
                    Your Digital Needs For Online Success
                  </h3>
                  <p class="">
                    Paval Soft offers complete digital solutions for your
                    business. We help you with all your online needs. From SEO
                    to API integration, we build your online success. Paval Soft
                    crafts digital solutions for your growth. We understand that
                    every client is different. We customize our services to meet
                    your needs. Our offerings cover all digital areas. You get
                    the technology you need to reach your goals
                  </p>
                  <div className="minifeature">
                    <p>Our key services include:</p>
                    <ol className="m-0">
                      <i class="fas fa-eraser me-2"></i>
                      <b>Website Development:</b> Creating engaging online
                      platforms for your brand.
                    </ol>
                    <ol className="m-0">
                      <i class="fas fa-eraser me-2"></i>
                      <b>Mobile Application Creation:</b> Connecting you with
                      customers on their phones.
                    </ol>
                    <ol className="m-0">
                      <i class="fas fa-eraser me-2"></i>
                      <b>SEO (Search Engine Optimization):</b> Helping your
                      business get found online.
                    </ol>
                    <ol className="m-0">
                      <i class="fas fa-eraser me-2"></i>
                      <b>Digital Marketing:</b> Encompasses various strategies
                      to reach and engage customers online.
                    </ol>
                    <ol className="m-0">
                      <i class="fas fa-eraser me-2"></i>
                      <b> IT Consulting:</b> Provides expert guidance to help
                      businesses make informed technology decisions.
                    </ol>
                  </div>

                  <p class="mb-0">
                    At Paval Soft, we offer complete digital support. We can
                    help you with everything digital. Explore our list of
                    packages. See how we can help you achieve your online goals.
                    We encourage your long-term growth.
                  </p>
                  <div className="cta mt-3 d-inline-flex">
                    <a href="https://www.pavalsoftware.com/" className="">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class=" col-md-6 d-inline-flex">
              <div class="handpic ms-auto">
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/handtech.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid  overflow-hide justify-contnet-center p-0">
          <div className="gredy_greenbg"></div>
          <div className="paval_server d-flex mx-auto">
            <div className="col-md-8 pt-5 d-inline-block paval_itemwrap m-auto">
              <div class=" col-md-6 mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item1.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/website-development">
                      <h5 class="h5 d-inline-block mb-2">
                        Website Development
                      </h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item2.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/ios-development">
                      <h5 class="h5 d-inline-block mb-2">iOS Development</h5>
                    </a>
                  </div>
                </div>
              </div>

              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item3.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/php-development">
                      <h5 class="h5 d-inline-block mb-2">PHP Development</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/game-development">
                      <h5 class="h5 d-inline-block mb-2">Game Development</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item5.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/devops">
                      <h5 class="h5 d-inline-block mb-2">DevOps</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6 mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item6.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/content-writting">
                      <h5 class="h5 d-inline-block mb-2">Content Writing</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item7.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/e-commerce">
                      <h5 class="h5 d-inline-block mb-2">E-Commerce</h5>
                    </a>
                  </div>
                </div>
              </div>

              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item8.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/wordpress">
                      <h5 class="h5 d-inline-block mb-2">WordPress</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item9.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/ui-ux-development">
                      <h5 class="h5 d-inline-block mb-2">UI&UX</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item10.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/search-engine-optimization-seo">
                      <h5 class="h5 d-inline-block mb-2">SEO</h5>
                    </a>
                  </div>
                </div>
              </div>

              <div class=" col-md-6 mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item11.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/mobile-application">
                      <h5 class="h5 d-inline-block mb-2">Mobile Application</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item12.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/internet-of-things-iot">
                      <h5 class="h5 d-inline-block mb-2">Internet of Things</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item13.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/generative-ai">
                      <h5 class="h5 d-inline-block mb-2">Generative AI</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item14.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/aws-cloud">
                      <h5 class="h5 d-inline-block mb-2">AWS cloud</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item15.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/android">
                      <h5 class="h5 d-inline-block mb-2">Android</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item16.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/artificial-intelligence-ai">
                      <h5 class="h5 d-inline-block mb-2">
                        Artificial Intelligence
                      </h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item17.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/digital-marketing">
                      <h5 class="h5 d-inline-block mb-2">Digital Marketing</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item18.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/machine-learning">
                      <h5 class="h5 d-inline-block mb-2">Machine Learning</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item19.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/block-chain">
                      <h5 class="h5 d-inline-block mb-2">Blockchain</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class=" col-md-6  mx-auto paval_serv_item  d-inline-block">
                <div class="d-flex paval__item_details">
                  <div class="pe-3">
                    <div class="service-btn">
                      <img
                        class="w-100 d-flex mx-auto"
                        src="assets/img/pavalsoft/item20.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="https://www.pavalsoftware.com/crm">
                      <h5 class="h5 d-inline-block mb-2">CRM</h5>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid grey_grady overflow-hide pavalfoot justify-contnet-center ps-0 py-5">
          <div className="col-md-12 pt-5 d-flex paval_though m-auto">
            <div class=" col-md-6 d-inline-flex">
              <div class="handpic ml-auto">
                <img
                  class="w-100 d-flex mx-auto"
                  src="assets/img/pavalsoft/cutomerphon.png"
                  alt=""
                />
              </div>
            </div>
            <div class=" col-md-6 d-inline-block ">
              <div class="paval_cust_details">
                <div>
                  <h3 class="d-inline-block mb-2">
                    Where Software Innovation Meets{" "}
                    <span className="title_green">Business Success</span>
                  </h3>
                  <p class="">
                    Paval Soft started in Coimbatore now to everywhere. For over
                    twelve years, we have provided IT power for your network. We
                    deliver many IT solutions for businesses. Our company offers
                    custom solutions. We build websites that fit your specific
                    needs. We create mobile applications that are user-friendly.
                    We work with CMS systems to manage your content. Custom
                    software development is another area of our expertise. We
                    also offer cloud services for scalability. AI and DevOps are
                    part of our modern solutions.
                  </p>
                  <p className="mb-5">
                    We solve your unique technology problems. We build solutions
                    designed to help your business grow. Our services include
                    creating e-commerce platforms to sell online. Digital
                    marketing helps you reach more customers. Paval Soft is your
                    single partner for all your software needs. We also provide
                    expert IT consulting. Our goal is to help you achieve
                    lasting success in the digital world. We focus on building
                    strong relationships with our clients. We believe in clear
                    communication and reliable support. Our team is dedicated to
                    your success. Let us help you the always evolving tech
                    world. We give you the resources and skills you require to
                    succeed.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class=" col-md-10 d-block mx-auto paval_footer">
            <div class="paval_foot_inner">
              <div className="col-md-12 d-flex">
                <div class=" col-md-4  ml-auto footerlogo d-flex">
                  <div className="logo d-flex pb-4">
                    <a href="https://www.pavalsoftware.com/" className="p-0">
                      <img
                        src="assets/img/pavalsoft/ps_logo.png"
                        alt="Pavalsoft"
                      />
                    </a>
                  </div>
                </div>
                <div class=" col-md-8 d-block">
                  <h5 class="d-inline-block mb-2 text-white">Our Services</h5>
                  <div class=" col-md-12 d-block">
                    <div class=" col-md-4 d-inline-flex">
                      <ul>
                        <li>
                          <a href="https://www.pavalsoftware.com/website-development">
                            Website Development
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/ios-development">
                            iOS Development
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/php-development">
                            PHP Development
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/game-development">
                            Game Development
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/devops">
                            DevOps
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/content-writting">
                            Content Writing
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/e-commerce">
                            E-Commerce
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class=" col-md-4 d-inline-flex">
                      <ul>
                        <li>
                          <a href="https://www.pavalsoftware.com/wordpress">
                            WordPress
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/ui-ux-development">
                            UI & UX
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/search-engine-optimization-seo">
                            Search Engine Optimization
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/mobile-application">
                            Mobile Application
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/internet-of-things-iot">
                            Internet of Things
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/generative-ai">
                            Generative AI
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/aws-cloud">
                            AWS Cloud
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class=" col-md-4 d-inline-flex">
                      <ul>
                        <li>
                          <a href="https://www.pavalsoftware.com/android">
                            Android
                          </a>
                        </li>

                        <li>
                          <a href="https://www.pavalsoftware.com/artificial-intelligence-ai">
                            Artificial Intelligence
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/digital-marketing">
                            Digital Marketing
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/machine-learning">
                            Machine Learning
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/block-chain">
                            Blockchain
                          </a>
                        </li>
                        <li>
                          <a href="https://www.pavalsoftware.com/crm">
                            CRM Technologies
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10 p-2 pe-0 ps-0 m-auto pavalfooter_term">
            <a href="https://www.pavalsoftware.com/privacy-policy">
              Privacy policy{" "}
            </a>{" "}
            <span>|</span>{" "}
            <a href="https://www.pavalsoftware.com/terms-conditions">
              Terms and Conditions
            </a>
          </div>

          <div className="pavalform">
            {showModal && (
              <div className={`modal-container ${closing ? "closing" : ""}`}>
                <div className="modal-content">
                  {/* Left Column: Logo */}
                  <div className="modal-logo">
                    <a href="https://www.pavalsoftware.com/" className="p-0">
                      <img
                        src="assets/img/pavalsoft/logoblack.png"
                        alt="Pavalsoft"
                      />
                    </a>
                  </div>
                  {/* Right Column: Form */}
                  <div className="modal-form">
                    <h5>Business Enquiry</h5>
                    <button className="close-btn" onClick={closeModal}>
                      <FaTimes />
                    </button>

                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="Full Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        maxLength={150}
                      />
                      {errors.firstName && <p>{errors.firstName}</p>}

                      <input
                        type="text"
                        name="businessName"
                        placeholder="Business Name"
                        value={formData.businessName}
                        onChange={handleChange}
                        maxLength={150}
                      />
                      {errors.businessName && <p>{errors.businessName}</p>}

                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors.email && <p>{errors.email}</p>}
                      <div className="phone-input-group">
                        <select
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={handleChange}
                          className="country-code-select"
                        >
                          {countryCodes.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.flag} {country.code}
                            </option>
                          ))}
                        </select>
                        <input
                          type="text"
                          name="phone"
                          placeholder="Contact Number"
                          value={formData.phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          className="phone-number-input"
                        />
                      </div>

                      {errors.phone && <p>{errors.phone}</p>}

                      <select
                        name="businessType"
                        value={formData.businessType}
                        onChange={handleChange}
                      >
                        <option value="">Select Business Type</option>
                        <option value="Website Development">
                          Website Development
                        </option>
                        <option value="iOS Development">iOS Development</option>
                        <option value="PHP Development">PHP Development</option>
                        <option value="Game Development">
                          Game Development
                        </option>
                        <option value="DevOps">DevOps</option>
                        <option value="Content Writing">Content Writing</option>
                        <option value="E-Commerce">E-Commerce</option>
                        <option value="WordPress">WordPress</option>
                        <option value="UI & UX">UI & UX</option>
                        <option value="Search Engine Optimization">
                          Search Engine Optimization
                        </option>
                        <option value="Mobile Application">
                          Mobile Application
                        </option>
                        <option value="Internet of Things">
                          Internet of Things
                        </option>
                        <option value="Generative AI">Generative AI</option>
                        <option value="AWS Cloud">AWS Cloud</option>
                        <option value="Android">Android</option>
                        <option value="Artificial Intelligence">
                          Artificial Intelligence
                        </option>
                        <option value="Digital Marketing">
                          Digital Marketing
                        </option>
                        <option value="Machine Learning">
                          Machine Learning
                        </option>
                        <option value="Blockchain">Blockchain</option>
                        <option value="CRM Technologies">
                          CRM Technologies
                        </option>
                      </select>
                      {errors.businessType && <p>{errors.businessType}</p>}

                      <textarea
                        name="enquiry"
                        placeholder="Your Message"
                        value={formData.enquiry}
                        onChange={handleChange}
                        maxLength={1500}
                      />
                      {errors.enquiry && <p>{errors.enquiry}</p>}

                      <div className="filesubmit">
                        <button
                          className="btn-grad"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Processing..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="whatsapp_chatboot">
        <a href="https://api.whatsapp.com/send/?phone=61449840901&text=Hi,%20I%27m%20interested%20in%20your%20Web/App%20development%20services.%20Can%20you%20Assist%20me?&type=phone_number&app_absent=0%20%20Share%20on%20WhatsApp%20%20WhatsApp%20Messenger:%20More%20than%202%20billion%20people%20%20%20%20%20%20%20%20%20%20%20%20in%20over%20180%20countries%20use%20WhatsApp%20to%20stay%20in%20touch%20with%20friends%20and%20%20%20%20%20%20%20%20%20%20%20%20family,%20anytime%20and%20anywhere.%20WhatsApp%20is%20free%20and%20offers%20sim...">
          <i class="fab fa-whatsapp"></i>
          <span>Whatsapp Now</span>
        </a>
      </div>
    </div>
  );
};

export default Pavalsoft_lp;
